import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './messages'

Vue.use(VueI18n)
// configure router

const i18n = new VueI18n({
  locale: 'pt', // set locale
  messages // set locale messages
})

export default i18n
